<template>
	<div class="modal is-active">
		<div class="modal-background" @click="cancel"></div>
		<div class="modal-card">
			<header class="modal-card-head" :class="{ mobile: isMobile }">
				<p v-if="localItem.id" class="modal-card-title">
					{{ localItem.fireProtection.name }}
				</p>
				<p v-else class="modal-card-title">Ny inventarie</p>
				<div v-if="isFireExtinguisher() && $isAllowedTo('floor_areas_edit')" class="header-select">
					<p>Inv. Grupp</p>
					<v-select
						class="panel-select"
						v-model="chosenInventoryGroup"
						:options="fireProtectionGroupMap"
						:placeholder="'Välj brandskydd'"
						:allowEmpty="false"
						:internalSearch="true"
						:showLabels="false"
						@input="filterFireProtections()"
						track-by="index"
						label="text"
					>
					</v-select>
				</div>
				<div v-if="isFireExtinguisher() && $isAllowedTo('floor_areas_edit')" class="header-select">
					<p>Inv. typ</p>
					<v-select
						class="panel-select"
						v-model="chosenInventoryType"
						:options="filterdfireProtections"
						:placeholder="'Välj brandskydd'"
						:allowEmpty="false"
						:internalSearch="true"
						:showLabels="false"
						track-by="id"
						label="name"
					>
						<span slot="noResult">Inga resultat</span>
						<span
							slot="caret"
							slot-scope="{ toggle }"
							class="caret"
							@mousedown.prevent.stop="toggle()"
						><i class="fas fa-caret-down caret-inner"></i
						></span>
					</v-select>
				</div>
				<div v-else class="addmapitem_subtitle">
					<p>Inventarietyp: {{ localItem.fireProtection.inventoryType }}</p>
				</div>
				<button class="delete" aria-label="close" @click="cancel"></button>
			</header>
			<section class="modal-card-body not-mobile">
				<div class="columns">
					<div class="column">
						<div class="field">
							<div class="label white">Årtal</div>
							<div class="control">
								<input
									class="input"
									type="number"
									v-model="localYear"
									:disabled="!$isAllowedTo('floor_areas_edit')"
								/>
							</div>
						</div>
						<div class="field">
							<div class="label white">Pos nr</div>
							<div class="control">
								<input
									class="input"
									type="number"
									v-model.number="localItem.positionNumber"
									:disabled="!$isAllowedTo('floor_areas_edit')"
								/>
							</div>
						</div>
						<div class="field">
							<div class="label white">Placering</div>
							<div class="control">
								<textarea
									class="textarea no-resize"
									rows="2"
									v-model="localItem.placementDescription"
									:disabled="!$isAllowedTo('floor_areas_edit')"
								/>
							</div>
						</div>
						<div class="field">
							<div class="label white">Instruktion</div>
							<div class="control">
								<textarea
									class="textarea no-resize"
									rows="3"
									disabled
									v-model="localItem.fireProtection.instruction"
									style="height: 99px;"
								/>
							</div>
						</div>
					</div>
					<div class="column">
						<div class="field">
							<div class="label white">Beskrivning</div>
							<div class="control">
								<textarea
									class="textarea no-resize"
									rows="4"
									disabled
									v-model="localItem.fireProtection.description"
								/>
							</div>
						</div>

						<div class="field" style="margin-top: 24px;">
							<div class="label white">Rekommendation</div>
							<div class="control">
								<textarea
									class="textarea no-resize"
									rows="4"
									disabled
									v-model="localItem.fireProtection.recommendation"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button
					class="button is-dark"
					:class="isLoading ? 'is-loading' : ''"
					@click="save"
					v-if="$isAllowedTo('floor_areas_edit')"
				>
					<span class="icon is-info"><i class="fas fa-save"/></span
					><span>Spara</span>
				</button>
				<button
					class="button is-dark"
					@click="deleteItem"
					v-if="$isAllowedTo('floor_areas_edit') && localItem.fireProtection.id"
				>
					<span class="icon"><i class="fas fa-trash"/></span>
					<span>Ta bort</span>
				</button>
				<button class="button is-dark" @click="cancel" v-if="$isAllowedTo('floor_areas_edit')">
					<span class="icon"><i class="fas fa-ban"/></span> <span>Avbryt</span>
				</button>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import iconMixin from '@/mixins/iconMixin.js';
export default {
	mixins: [iconMixin],
	props: {
		item: Object,
		fireProtections: Array,
		hasMapFile: Boolean
	},
	data() {
		return {
			fireProtectionOptions: [],
			filterdfireProtections: [],
			chosenInventoryType: null,
			chosenInventoryGroup: null,
			fireProtectionGroupMap: [],
			localItem: {},
			isLoading: false,
			localYear: ''
		};
	},
	computed: {
		...mapState('fireProtectionStore', ['fireExtinguishers']),
		...mapGetters('appStore', ['isMobile']),
		year() {
			if (this.localYear) {
				return this.localYear;
			}

			return '';
		}
	},
	watch: {
		chosenInventoryType: function(to) {
			this.localItem.fireProtection = to;
		},
		year: function(val) {
			if (val.length >= 4) {
				this.localYear = val.substr(0, 4);
			}
		}
	},
	methods: {
		getFireProtectionOptions() {
			if (this.hasMapFile && !this.isMobile) {
				let extinguisherOptions = JSON.parse(
					JSON.stringify(this.fireProtections)
				).reduce((acc, fireprot) => {
					if (
						this.fireExtinguishers.some(
							extinguisher => extinguisher === fireprot.inventoryType
						)
					)
						acc.push(fireprot);

					return acc;
				}, []);

				return extinguisherOptions;
			} else {
				return this.fireProtections;
			}
		},
		filterFireProtections() {
			if (this.chosenInventoryGroup.index > -1) {
				this.filterdfireProtections = this.fireProtectionOptions.filter(
					x => x.fireProtectionType === this.chosenInventoryGroup.index
				);
				this.chosenInventoryType = this.filterdfireProtections[0];

				return;
			}

			this.filterdfireProtections = this.fireProtectionOptions;
			this.chosenInventoryType = this.filterdfireProtections[0];
		},
		save() {
			this.localItem.fireProtection = this.chosenInventoryType;
			this.localItem.fireProtectionId = this.localItem.fireProtection.id;

			if (this.localYear && this.localYear !== '0001') {
				this.localItem.year = new Date(parseInt(this.localYear, 10), 0, 1, 1);
			}

			if (this.localItem.map) {
				this.localItem.mapId = this.localItem.map.id;
			}

			if (!this.isLoading) {
				this.$emit('save', this.localItem);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		},
		isFireExtinguisher() {
			if (this.hasMapFile && !this.isMobile) {
				return this.fireExtinguishers.some(
					extinguisher =>
						extinguisher === this.localItem.fireProtection.inventoryType
				);
			} else {
				return true;
			}
		},
		deleteItem() {
			this.$emit('delete', this.localItem);
		}
	},
	created() {
		this.localItem = Object.assign({}, this.item);

		if (this.item.fireProtection) {
			this.chosenInventoryType = this.item.fireProtection;
			this.localYear = this.localItem.year.substring(0, 4);
		} else {
			this.chosenInventoryType = Object.assign({}, this.fireProtections[0]);
			this.localItem.fireProtection = Object.assign(
				{},
				this.fireProtections[0]
			);
		}

		this.fireProtectionGroupMap = Object.values(
			this.getFireProtectionGroupMap()
		).map((item, index) => {
			return { index, text: item };
		});

		this.filterdfireProtections,
		(this.fireProtectionOptions = this.getFireProtectionOptions());
		this.fireProtectionGroupMap.unshift({ index: -1, text: 'Alla valda' });
		this.chosenInventoryGroup = this.fireProtectionGroupMap[0];
	}
};
</script>
<style lang="scss" scoped>
.modal-card-head {
  display: block;
  flex-wrap: wrap;
  .delete {
    position: absolute;
    top: 0.65rem;
    right: 0.6rem;
  }
  &.mobile {
    .modal-card-title {
      min-width: 150px;
    }
  }
}
</style>
<style lang="scss">
.addmapitem_subtitle {
  font-size: 1.25rem;
  color: #f3f3f3;
  float: right;
}
.addmapitem_subtitle {
  margin-right: 20px;
}
.header-select {
  position: relative;
  // margin-left: auto;
  margin-top: 0.5rem;

  margin-bottom: -5px;
  // width: 200px;
  display: flex;
  p {
    white-space: nowrap;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
  }
}
</style>
